export class Endereco {
    cep = '';
    logradouro = '';
    bairro = '';
    cidade = '';
    uf = '';
    complemento= '';
    codigoIbge = '';
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}



// WEBPACK FOOTER //
// ./src/app/models/endereco.ts